// Mock data for Whiplash Gear Inventory prototype

export const LOGO_URL =
  'https://customer-assets.emergentagent.com/job_shoot-organizer-1/artifacts/3jmotfdo_WC%20Logo%202018%20FULL%20Outlined%20WHITE.png';

// Black-on-transparent variant for light backgrounds (PDF pull sheet, print).
export const LOGO_DARK_URL =
  'https://customer-assets-v7afamib.emergentagent.net/job_airtable-rebuild/artifacts/1wl2j4gn_WC%20Logo%202018%20FULL%20Outlined%20BLACK.png';

// Category data now lives in MongoDB and is served via /api/categories.
// See AppContext for `categories` and `categoryColor`. Kept only LOGO_URL here.

const IMG_CAMERA = 'https://images.unsplash.com/photo-1516961642265-531546e84af2?crop=entropy&cs=srgb&fm=jpg&q=80&w=400';
const IMG_CAMERA2 = 'https://images.unsplash.com/photo-1495121553079-4c61bcce1894?crop=entropy&cs=srgb&fm=jpg&q=80&w=400';
const IMG_LENS = 'https://images.unsplash.com/photo-1612548403247-aa2873e9422d?crop=entropy&cs=srgb&fm=jpg&q=80&w=400';
const IMG_VIDEOGEAR = 'https://images.unsplash.com/photo-1535540878298-a155c6d065ef?crop=entropy&cs=srgb&fm=jpg&q=80&w=400';
const IMG_VIDEOGEAR2 = 'https://images.unsplash.com/photo-1553166272-e69910ab5ae1?crop=entropy&cs=srgb&fm=jpg&q=80&w=400';
const IMG_LIGHT = 'https://images.unsplash.com/photo-1471341971476-ae15ff5dd4ea?crop=entropy&cs=srgb&fm=jpg&q=80&w=400';
const IMG_LIGHT2 = 'https://images.pexels.com/photos/30332804/pexels-photo-30332804.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=400';
const IMG_LIGHT3 = 'https://images.pexels.com/photos/29877910/pexels-photo-29877910.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=400';
const IMG_MIC = 'https://images.unsplash.com/photo-1527261834078-9b37d35a4a32?crop=entropy&cs=srgb&fm=jpg&q=80&w=400';
const IMG_MIC2 = 'https://images.unsplash.com/photo-1521424159246-e4a66f267e4b?crop=entropy&cs=srgb&fm=jpg&q=80&w=400';
const IMG_MIC3 = 'https://images.unsplash.com/photo-1485579149621-3123dd979885?crop=entropy&cs=srgb&fm=jpg&q=80&w=400';
const IMG_MIC4 = 'https://images.pexels.com/photos/586416/pexels-photo-586416.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=400';

export const MOCK_ITEMS = [
  // Cameras
  { code: 'WC0002', name: 'Canon C200', category: 'Cameras', location: 'Fort Worth, TX', totalQty: 1, image: IMG_CAMERA },
  { code: 'WC0003', name: 'Sony A7RII', category: 'Cameras', location: 'Fort Worth, TX', totalQty: 1, image: IMG_CAMERA2 },
  { code: 'WC0008', name: 'Insta360 Pro 2', category: 'Cameras', location: 'Fort Worth, TX', totalQty: 1, image: IMG_CAMERA },
  { code: 'WC0041', name: 'GoPro Hero 7 Black', category: 'Cameras', location: 'Fort Worth, TX', totalQty: 1, image: IMG_CAMERA2 },
  { code: 'WC0075', name: 'Blackmagic Design 6K Pro', category: 'Cameras', location: 'Fort Worth, TX', totalQty: 2, image: IMG_CAMERA },
  { code: 'WC0099', name: 'Canon R5 C', category: 'Cameras', location: 'Fort Worth, TX', totalQty: 1, image: IMG_CAMERA2 },
  { code: 'WC0148', name: 'DJI Ronin 4D-8K', category: 'Cameras', location: 'Fort Worth, TX', totalQty: 1, image: IMG_CAMERA },
  { code: 'WC0159', name: 'DJI Action 5 Pro', category: 'Cameras', location: 'Fort Worth, TX', totalQty: 1, image: IMG_CAMERA2 },

  // Lenses
  { code: 'WC0004', name: 'Canon EF 70-200mm 2.8', category: 'Lenses', location: 'Fort Worth, TX', totalQty: 1, image: IMG_LENS },
  { code: 'WC0007', name: 'Canon EF 24-105mm 4.0', category: 'Lenses', location: 'Fort Worth, TX', totalQty: 1, image: IMG_LENS },
  { code: 'WC0016', name: 'DZOFilm Vespid 35mm T1.9 Prime', category: 'Lenses', location: 'Fort Worth, TX', totalQty: 1, image: IMG_LENS },
  { code: 'WC0150', name: 'Rokinon 85mm T1.5 DSX Cine (RF)', category: 'Lenses', location: 'Fort Worth, TX', totalQty: 1, image: IMG_LENS },
  { code: 'WC0155', name: 'DJI 17-23mm T3 Zoom Lens', category: 'Lenses', location: 'Fort Worth, TX', totalQty: 1, image: IMG_LENS },
  { code: 'WC0156', name: 'Sigma 28-70mm 2.8 Zoom Lens', category: 'Lenses', location: 'Fort Worth, TX', totalQty: 1, image: IMG_LENS },

  // Lighting
  { code: 'WC0020', name: 'Aladdin 1x2 Light', category: 'Lighting', location: 'Fort Worth, TX', totalQty: 1, image: IMG_LIGHT },
  { code: 'WC0021', name: 'Aladdin 1x1 Light (A)', category: 'Lighting', location: 'Fort Worth, TX', totalQty: 1, image: IMG_LIGHT2 },
  { code: 'WC0023', name: 'Lume Cube Lights', category: 'Lighting', location: 'Fort Worth, TX', totalQty: 4, image: IMG_LIGHT3 },
  { code: 'WC0080', name: 'Aputure P300C Light', category: 'Lighting', location: 'Fort Worth, TX', totalQty: 1, image: IMG_LIGHT },
  { code: 'WC0094', name: 'Zhiyun Molus B500', category: 'Lighting', location: 'Fort Worth, TX', totalQty: 1, image: IMG_LIGHT2 },
  { code: 'WC0107', name: 'Zhiyun Molus G200', category: 'Lighting', location: 'Fort Worth, TX', totalQty: 3, image: IMG_LIGHT3 },
  { code: 'WC0136', name: 'Amaran P21c', category: 'Lighting', location: 'Fort Worth, TX', totalQty: 1, image: IMG_LIGHT },
  { code: 'WC0142', name: 'SmallRig RC-100B COB', category: 'Lighting', location: 'Fort Worth, TX', totalQty: 2, image: IMG_LIGHT2 },

  // Microphones
  { code: 'WC0011', name: 'Sennheiser AVX Wireless Lav', category: 'Microphones', location: 'Fort Worth, TX', totalQty: 1, image: IMG_MIC },
  { code: 'WC0012', name: 'Sennheiser Wireless Lav', category: 'Microphones', location: 'Fort Worth, TX', totalQty: 1, image: IMG_MIC2 },
  { code: 'WC0017', name: 'StudioSonic Shotgun Microphone', category: 'Microphones', location: 'Fort Worth, TX', totalQty: 1, image: IMG_MIC3 },
  { code: 'WC0090', name: 'audio-technica AT2040 Podcast Mic', category: 'Microphones', location: 'Fort Worth, TX', totalQty: 3, image: IMG_MIC4 },
  { code: 'WC0151', name: 'Deity Theos Wireless Mic System', category: 'Microphones', location: 'Fort Worth, TX', totalQty: 1, image: IMG_MIC },
  { code: 'WC0160', name: 'Deity D4 Mini Shotgun Mic', category: 'Microphones', location: 'Fort Worth, TX', totalQty: 1, image: IMG_MIC2 },

  // Batteries
  { code: 'WC0064', name: 'Canon C200 Batteries', category: 'Batteries', location: 'Fort Worth, TX', totalQty: 2, image: IMG_VIDEOGEAR },
  { code: 'WC0067', name: 'Sony A7RII Batteries', category: 'Batteries', location: 'Fort Worth, TX', totalQty: 3, image: IMG_VIDEOGEAR2 },
  { code: 'WC0084', name: 'Juicebox V-Mount Battery (A)', category: 'Batteries', location: 'Fort Worth, TX', totalQty: 4, image: IMG_VIDEOGEAR },
  { code: 'WC0110', name: 'Canon R5 C Batteries', category: 'Batteries', location: 'Fort Worth, TX', totalQty: 5, image: IMG_VIDEOGEAR2 },
  { code: 'WC0127', name: 'Neewer V-Mount Batteries', category: 'Batteries', location: 'Fort Worth, TX', totalQty: 6, image: IMG_VIDEOGEAR },
  { code: 'WC0153', name: 'Ronin 4D Batteries', category: 'Batteries', location: 'Fort Worth, TX', totalQty: 3, image: IMG_VIDEOGEAR2 },
  { code: 'WC0158', name: 'Powerbase Edge Snap Xtreme V-Mount', category: 'Batteries', location: 'Fort Worth, TX', totalQty: 1, image: IMG_VIDEOGEAR },

  // External Recorders / Monitors
  { code: 'WC0083', name: 'Atomos Shinobi', category: 'External Recorders/Monitors', location: 'Fort Worth, TX', totalQty: 1, image: IMG_VIDEOGEAR },
  { code: 'WC0109', name: 'Atomos Shogun Ultra', category: 'External Recorders/Monitors', location: 'Fort Worth, TX', totalQty: 1, image: IMG_VIDEOGEAR2 },
  { code: 'WC0119', name: 'Atomos Ninja Ultra', category: 'External Recorders/Monitors', location: 'Fort Worth, TX', totalQty: 1, image: IMG_VIDEOGEAR },

  // Audio Recorders
  { code: 'WC0014', name: 'Zoom H4N Recorder', category: 'Audio Recorders', location: 'Fort Worth, TX', totalQty: 1, image: IMG_VIDEOGEAR2 },
  { code: 'WC0101', name: 'Zoom F3 Field Recorder', category: 'Audio Recorders', location: 'Fort Worth, TX', totalQty: 1, image: IMG_VIDEOGEAR },
  { code: 'WC0102', name: 'Tascam Audio For R5 C', category: 'Audio Recorders', location: 'Fort Worth, TX', totalQty: 1, image: IMG_VIDEOGEAR2 },

  // Tripods
  { code: 'WC0029', name: 'Manfrotto Tripod (Small)', category: 'Tripods/Monopods', location: 'Fort Worth, TX', totalQty: 1, image: IMG_VIDEOGEAR },
  { code: 'WC0031', name: 'Sachtler Tripod', category: 'Tripods/Monopods', location: 'Fort Worth, TX', totalQty: 1, image: IMG_VIDEOGEAR2 },

  // Sliders
  { code: 'WC0033', name: 'Glide Gear Dolly Slider', category: 'Sliders/Dollys/Rigs', location: 'Fort Worth, TX', totalQty: 1, image: IMG_VIDEOGEAR },

  // Gimbals
  { code: 'WC0088', name: 'Zhiyun Weebill 3E', category: 'Gimbals/Stabilizers', location: 'Fort Worth, TX', totalQty: 1, image: IMG_VIDEOGEAR2 },
  { code: 'WC0131', name: 'DJI RS 3 Pro Gimbal', category: 'Gimbals/Stabilizers', location: 'Fort Worth, TX', totalQty: 1, image: IMG_VIDEOGEAR },

  // Focus Control
  { code: 'WC0049', name: 'DJI Focus Pro LiDAR', category: 'Focus Control', location: 'Fort Worth, TX', totalQty: 1, image: IMG_VIDEOGEAR2 },
  { code: 'WC0085', name: 'Tilta Nano Wireless Follow Focus Kit 2', category: 'Focus Control', location: 'Fort Worth, TX', totalQty: 1, image: IMG_VIDEOGEAR },

  // Media
  { code: 'WC0146', name: 'Wise Media 512GB', category: 'Media', location: 'Fort Worth, TX', totalQty: 2, image: IMG_VIDEOGEAR2 },
  { code: 'WC0164', name: 'Angelbird 2 TB SSD', category: 'Media', location: 'Fort Worth, TX', totalQty: 2, image: IMG_VIDEOGEAR },

  // Lighting/Gear Stands
  { code: 'WC0070', name: 'Neewer Light Stands', category: 'Lighting/Gear Stands', location: 'Fort Worth, TX', totalQty: 3, image: IMG_LIGHT },
  { code: 'WC0114', name: 'Neewer C-Stands', category: 'Lighting/Gear Stands', location: 'Fort Worth, TX', totalQty: 2, image: IMG_LIGHT2 },

  // Grip
  { code: 'WC0042', name: 'IKAN Teleprompter Kit', category: 'Grip', location: 'Fort Worth, TX', totalQty: 1, image: IMG_VIDEOGEAR },
  { code: 'WC0043', name: 'Apple iPad Pro 12.9"', category: 'Grip', location: 'Fort Worth, TX', totalQty: 1, image: IMG_VIDEOGEAR2 },

  // Misc
  { code: 'WC0166', name: 'Starlink Mini', category: 'Misc', location: 'Fort Worth, TX', totalQty: 1, image: IMG_VIDEOGEAR },
].map((it, idx) => ({
  id: `item_${idx + 1}`,
  qrCode: it.code,
  ...it,
}));

export const MOCK_KITS = [
  {
    id: 'kit_1',
    code: 'KIT001',
    qrCode: 'KIT001',
    name: 'C200 Run-and-Gun Kit',
    description: 'Canon C200 body, zoom lens, monitor, batteries — everything to grab and go.',
    image: IMG_CAMERA,
    itemCodes: ['WC0002', 'WC0007', 'WC0064', 'WC0083', 'WC0031'],
  },
  {
    id: 'kit_2',
    code: 'KIT002',
    qrCode: 'KIT002',
    name: 'R5 C Cinema Kit',
    description: 'Canon R5 C with cinema primes, Shogun Ultra, follow focus, V-mount power.',
    image: IMG_CAMERA2,
    itemCodes: ['WC0099', 'WC0150', 'WC0156', 'WC0109', 'WC0085', 'WC0110', 'WC0102'],
  },
  {
    id: 'kit_3',
    code: 'KIT003',
    qrCode: 'KIT003',
    name: 'Interview Lighting Kit',
    description: '3-point lighting setup with stands, modifiers, and a wireless lav system.',
    image: IMG_LIGHT,
    itemCodes: ['WC0080', 'WC0136', 'WC0020', 'WC0070', 'WC0011'],
  },
  {
    id: 'kit_4',
    code: 'KIT004',
    qrCode: 'KIT004',
    name: 'Gimbal B-Roll Kit',
    description: 'DJI RS 3 Pro with focus, batteries, monitor, and media.',
    image: IMG_VIDEOGEAR,
    itemCodes: ['WC0131', 'WC0049', 'WC0119', 'WC0146', 'WC0084'],
  },
];

// Project lifecycle: 'active' | 'completed'
// Future: externalProjectId for sync with projects.whiplashfilmcreative.com
export const MOCK_PROJECTS = [
  {
    id: 'prj_1',
    name: 'Acme Corp Brand Video',
    client: 'Acme Corporation',
    location: 'Dallas, TX',
    shootDates: ['2025-08-12', '2025-08-13'],
    notes: 'Two-day shoot. CEO interview Day 1, b-roll Day 2.',
    status: 'active',
    externalProjectId: null,
    createdAt: '2025-08-01T10:00:00Z',
    // Gear list: items + kits requested for this project
    itemCodes: ['WC0099', 'WC0150', 'WC0156', 'WC0080', 'WC0070'],
    kitCodes: ['KIT003'],
    // Packing state: which item codes have been marked packed (qty by code)
    packed: { WC0099: 1, WC0150: 1 },
  },
  {
    id: 'prj_2',
    name: 'Pinewood Marketing Spot',
    client: 'Pinewood Studios',
    location: 'Austin, TX',
    shootDates: ['2025-08-20'],
    notes: 'Single day commercial. Run-and-gun style.',
    status: 'active',
    externalProjectId: null,
    createdAt: '2025-08-05T14:00:00Z',
    itemCodes: ['WC0131', 'WC0049'],
    kitCodes: ['KIT001'],
    packed: {},
  },
  {
    id: 'prj_3',
    name: 'Riverside Wedding Highlight',
    client: 'Johnson Family',
    location: 'Fort Worth, TX',
    shootDates: ['2025-07-15'],
    notes: 'Completed. All gear returned in good condition.',
    status: 'completed',
    externalProjectId: null,
    createdAt: '2025-07-10T09:00:00Z',
    itemCodes: ['WC0088', 'WC0011'],
    kitCodes: ['KIT004'],
    packed: { WC0131: 1, WC0049: 1, WC0119: 1, WC0146: 1, WC0084: 1, WC0088: 1, WC0011: 1 },
    completedAt: '2025-07-16T18:00:00Z',
  },
];

export const ADMIN_USER = {
  email: 'greg.norton@whiplashcreative.com',
  name: 'Greg Norton',
  role: 'admin',
};
